/**
 * SolutionExecuteStatus - describe lifecycle of single action
 * new - execution just started;
 * inProgress - some executor stated to work with data
 * @enum
 */
export enum RecoverySolutionExecuteStatus {
  new,
  inProgress,
  resolved,
  fail
}
